<template>
  <div>
    <div
      class="d-flex mx-2 mb-2 container-select"
      v-if="show_grade_range_list && grade_ranges_groups.length > 1"
    >
      <div class="text-selector align-self-center mr-2">
        {{ $t("toolbar.reports.selectGradeRange") }}:
      </div>
      <b-form-select
        v-model="selected_grade_range_group"
        :options="gradeRangesGroups"
        value-field="id"
        text-field="label"
        size="sm"
      >
      </b-form-select>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "GradeRangeGroupSelector",
  components: {},
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selected_grade_range_group: null,
      show_grade_range_list: true,
      grade_ranges_groups: [],
      grade_ranges: [],
    };
  },
  computed: {
    gradeRangesGroups() {
      return this.grade_ranges_groups.map((x) => {
        const grade_range = this.grade_ranges
          .filter((g) => g.grade_range_group == x.id)
          .map(
            (a) =>
              `${a.name} [${a.start_grade} ${
                a.include_start_grade ? "≤" : "<"
              } x ${a.include_finish_grade ? "≤" : "<"} ${a.finish_grade}]`
          )
          .join(", ");

        return {
          ...x,
          label: `${x.name}: ${grade_range}`,
        };
      });
    },
  },
  methods: {
    getGradeRange() {
      this.$restful.GetAll("/evaluations2/grade-range-group/").then((response) => {
        this.grade_ranges_groups = response;
      });
      this.$restful.GetAll("/evaluations2/grade-range/").then((response) => {
        this.grade_ranges = response;
      });
    },
  },
  watch: {
    selected_grade_range_group(value) {
      if (value != null) this.$emit("selected_range_group", value);
    },
  },
  created() {
    this.getGradeRange();
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((egress_profile) => {
        this.$store
          .dispatch(names.FETCH_CAREER, egress_profile.career)
          .then((career) => {
            this.selected_grade_range_group = career.chosen_grade_range_group;
            if (career.chosen_grade_range_group != null)
              this.show_grade_range_list = false;
            // Necesario para que en GradeRangeSection se muestre la tabla.
            if (career.chosen_grade_range_group == null)
              this.$emit("selected_range_group", null);
          });
      });
  },
};
</script>

<style scoped>
.container-select {
  background-color: var(--kl-menu-color) !important;
  border-radius: 3px;
  padding: 7px;
  color: white;
  align-items: center;
}
.text-selector {
  width: 18%;
}
</style>

